/* tslint:disable */
/* eslint-disable */
/**
 * Agrinorm Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { FieldSection } from './field-section';
// May contain unused imports in some cases
// @ts-ignore
import { QuestionSpec } from './question-spec';
// May contain unused imports in some cases
// @ts-ignore
import { ScorespecsInner } from './scorespecs-inner';

/**
 *
 * @export
 * @interface FieldSchema
 */
export interface FieldSchema {
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  creationDate: string;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  lastModifiedDate: string;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  lastModifiedUserId?: string;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof FieldSchema
   */
  version: number;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  orgId: string;
  /**
   *
   * @type {Array<QuestionSpec>}
   * @memberof FieldSchema
   */
  questionSpecs?: Array<QuestionSpec>;
  /**
   * Inspection-level score specification
   * @type {Array<ScorespecsInner>}
   * @memberof FieldSchema
   */
  scoreSpecs?: Array<ScorespecsInner>;
  /**
   *
   * @type {string}
   * @memberof FieldSchema
   */
  objectType?: FieldSchemaObjectTypeEnum;
  /**
   *
   * @type {Array<FieldSection>}
   * @memberof FieldSchema
   */
  sections?: Array<FieldSection>;
  /**
   *
   * @type {Array<string>}
   * @memberof FieldSchema
   */
  agProductIds?: Array<string>;
}

export const FieldSchemaObjectTypeEnum = {
  Field: 'field',
} as const;

export type FieldSchemaObjectTypeEnum =
  (typeof FieldSchemaObjectTypeEnum)[keyof typeof FieldSchemaObjectTypeEnum];
